import { createContext, useContext } from 'react';
import globals from '../utils/globals';

export const GlobalsContext = createContext(globals);

export const useGlobalsContext = () => useContext(GlobalsContext);
